/**
 * El único `import()` de la evaluación. Lo usan su ruta y la precarga del resumen: con un solo punto de
 * carga, webpack arma un solo chunk, y la precarga le sirve a la navegación con cualquier configuración de
 * chunks comunes. Dos `import()` del mismo módulo pueden terminar en dos chunks distintos.
 */
export const loadEvaluationModule = () => import('./evaluation.module');
